// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root{height:15;border-radius:5}.colorPrimary{background-color:\"#EEEEEE\"}.bar{border-radius:5;background-color:'#1a90ff'}.upload-message{font-weight:bold;color:#63A84E;margin-top:20px !important}.upload-message.error{color:#DA4148}.btn-no-mrg{margin:0px !important}.MuiButton-outlined{padding:8px 15px !important}.select-ht .css-yk16xz-control{max-height:53px;min-height:0px !important}\n", ""]);
// Exports
module.exports = exports;
